import { cn as e } from "../cn.js";
import { tooltipArrowStyles as t, tooltipContentStyles as n, tooltipPositioningDefaults as r } from "./styles.js";
import * as i from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Tooltip as s } from "@ark-ui/react/tooltip";
// src/design/tooltip/Tooltip.tsx
var c = i.forwardRef(({ children: e, positioning: t = {}, ...n }, i) => {
	let { placement: o = "top", gutter: c = r.gutter, offset: l = r.offset, boundary: u, flip: d = r.flip, sameWidth: f = r.sameWidth, fitViewport: p = r.fitViewport } = t;
	return /* @__PURE__ */ a(s.Root, {
		...n,
		positioning: {
			placement: o,
			gutter: c,
			offset: l,
			boundary: u,
			flip: d,
			sameWidth: f,
			fitViewport: p
		},
		children: /* @__PURE__ */ a("div", {
			ref: i,
			className: "inline-flex",
			children: e
		})
	});
});
c.displayName = "TooltipRoot";
var l = i.forwardRef(({ children: e, asChild: t = !0, ...n }, r) => /* @__PURE__ */ a(s.Trigger, {
	asChild: t,
	...n,
	children: e
}));
l.displayName = "TooltipTrigger";
var u = i.forwardRef(({ children: e, className: t, ...n }, r) => /* @__PURE__ */ a(s.Positioner, {
	ref: r,
	className: t,
	...n,
	children: e
}));
u.displayName = "TooltipPositioner";
var d = i.forwardRef(({ children: t, variant: r = "default", size: i = "md", className: o, ...c }, l) => /* @__PURE__ */ a(s.Content, {
	ref: l,
	className: e(n({
		variant: r,
		size: i
	}), o),
	...c,
	children: t
}));
d.displayName = "TooltipContent";
var f = i.forwardRef(({ variant: n = "default", className: r, ...i }, o) => /* @__PURE__ */ a(s.Arrow, {
	ref: o,
	className: e(t({ variant: n }), r),
	...i,
	children: /* @__PURE__ */ a(s.ArrowTip, {})
}));
f.displayName = "TooltipArrow";
var p = i.forwardRef(({ content: e, children: t, variant: n = "default", size: r = "md", showArrow: i = !1, className: s, placement: p, positioning: m, ...h }, g) => {
	let _ = p ? {
		...m,
		placement: p
	} : m;
	return /* @__PURE__ */ o(c, {
		ref: g,
		positioning: _,
		...h,
		children: [/* @__PURE__ */ a(l, { children: t }), /* @__PURE__ */ a(u, { children: /* @__PURE__ */ o(d, {
			variant: n,
			size: r,
			className: s,
			children: [i && /* @__PURE__ */ a(f, { variant: n }), e]
		}) })]
	});
});
p.displayName = "Tooltip";
var m = Object.assign(p, {
	Root: c,
	Trigger: l,
	Positioner: u,
	Content: d,
	Arrow: f
});
export { f as Arrow, f as TooltipArrow, d as Content, d as TooltipContent, u as Positioner, u as TooltipPositioner, c as Root, c as TooltipRoot, m as Tooltip, l as TooltipTrigger, l as Trigger };

//# sourceMappingURL=Tooltip.js.map